import { apiGet, apiPost } from './apiClient';

async function readJsonOrThrow(res, action) {
    const text = await res.text().catch(() => '');
    if (!res.ok) {
        throw new Error(text || `Failed to ${action} (${res.status})`);
    }
    if (!text) return null;
    try {
        return JSON.parse(text);
    } catch {
        throw new Error(`${action}: server returned non-JSON: ${text.slice(0, 200)}`);
    }
}

export async function fetchCreditsOverview() {
    const res = await apiGet('credits/overview');
    return readJsonOrThrow(res, 'fetch credits');
}

export async function searchCompanies(query) {
    const res = await apiPost('companies/search', { search_term: query });
    const data = await readJsonOrThrow(res, 'search companies');
    // SearchService treats the response as a plain array.
    return Array.isArray(data) ? { companies: data } : data;
}

// Reuses the existing POST /company endpoint that CompanyPage.fetchCompanyData
// uses. Response shape is { data: { ..., topics: [{..., competitors: [...]}] } }
// — each topic already comes hydrated with its competitor list from the
// existing topic_competitors join.
export async function fetchCompanyTopics(companyId) {
    const res = await apiPost('company', { id: companyId });
    const body = await readJsonOrThrow(res, 'fetch company');
    return { topics: body?.data?.topics || [] };
}

export async function requestTopic({ companyId, topic, relationship, additional_text }) {
    const res = await apiPost('topic-requests', {
        company_id: companyId,
        topic,
        relationship,
        additional_text: additional_text || '',
    });
    return readJsonOrThrow(res, 'request topic');
}

export async function createCompany({ name, url }) {
    const res = await apiPost('companies', { name, url });
    return readJsonOrThrow(res, 'create company');
}

export async function deleteProject(projectId) {
    const res = await apiPost(`projects/${projectId}/delete`, {});
    return readJsonOrThrow(res, 'delete project');
}

export async function createProjectRequest({ name, companyId, reviewCap, topics }) {
    const res = await apiPost('projects', {
        name,
        company_id: companyId,
        review_cap: reviewCap,
        topics: topics.map(t => ({
            topic_id: t.topicId,
            canned_assessments: t.cannedAssessments,
            custom_questions: t.customQuestions,
            competitor_topic_ids: t.competitorTopicIds,
        })),
    });
    return readJsonOrThrow(res, 'create project');
}
